export const json = {
  locale: 'es_es',
  recipe: "Receta",
  machine: "Máquina",
  task: {
    state: {
      unset: "No establecido",
      todo: "Por hacer",
      in_progress: "En progreso",
      to_test: "Para probar",
      wont_fix: "No se arreglará",
      done: "Hecho",
      paused: "Pausado",
    },
    priority: {
      unset: "Sin prioridad",
      low: "Baja",
      normal: "Normal",
      high: "Alta",
      max: "Urgente",
    },
    table: {
      header: {
        title: "Tarea",
        state: "Estado",
        priority: "Prioridad",
        labels: "Etiquetas",
      },
      placeholder: {
        filter: {
          priority: "Filtrar correos...",
        },
      },
      "no-results": "Sin resultados",
    },
    add: {
      title: "Añadir nueva tarea",
      name: "Nombre de la tarea",
      name_placeholder: "Introduce el nombre de la tarea",
      priority: "Prioridad",
      title_translations: "Traducciones del título",
      description_translations: "Traducciones de la descripción",
      icon_url: "URL del icono (opcional)",
      icon_url_placeholder: "Introduce la URL del icono",
      labels: "Etiquetas",
      assigned_to: "Asignado a",
      assigned_to_placeholder: "Seleccionar moderador",
      submit: "Crear tarea",
      cancel: "Cancelar",
      edit_translations: "Editar traducciones",
      save_translations: "Guardar traducciones",
      required_field: "Este campo es obligatorio",
      en_us_required: "La traducción al inglés (EE. UU.) es obligatoria",
      success: "¡Tarea creada con éxito!",
      error: "Error al crear la tarea. Por favor, inténtalo de nuevo.",
    },
  },
  table: {
    select: {
      of: "de",
      rows: "fila(s) seleccionada(s).",
    },
  },
  cookies: {
    link: 'Política de Cookies',
    title: "Consentimiento de cookies",
    description:
      "Este sitio web utiliza cookies para garantizar su correcto funcionamiento y mejorar tu experiencia. Por favor, selecciona qué cookies nos permites utilizar.",
    policy_link: "Más información en nuestra Política de Cookies",
    accept_all: "Aceptar todas",
    accept_selected: "Aceptar seleccionadas",
    accept_essential: "Solo esenciales",
    manage: "Gestionar preferencias",
    save: "Guardar preferencias",
    back: "Volver",
    categories: {
      essential: {
        title: "Cookies esenciales",
        description: "Estas cookies son necesarias para el funcionamiento del sitio web y no pueden ser desactivadas.",
      },
      functional: {
        title: "Cookies funcionales",
        description: "Estas cookies permiten características y funcionalidades personalizadas.",
      },
      analytics: {
        title: "Cookies analíticas",
        description: "Estas cookies nos ayudan a entender cómo los visitantes interactúan con el sitio web.",
      },
      marketing: {
        title: "Cookies de marketing",
        description: "Estas cookies se utilizan para rastrear a los visitantes a través de sitios web con fines publicitarios.",
      },
    },
    expiration: {
      title: "Caducidad de cookies",
      description: "Elige cuánto tiempo se recordarán tus preferencias de cookies:",
      thirty_days: "30 días",
      ninety_days: "90 días",
      six_months: "6 meses",
      one_year: "1 año",
    },
    policy: {
      title: "Política de cookies",
      introduction:
        "Esta Política de Cookies explica cómo utilizamos cookies y tecnologías similares para reconocerte cuando visitas nuestro sitio web. Explica qué son estas tecnologías y por qué las utilizamos, así como tus derechos para controlar nuestro uso de ellas.",
      what_are_cookies: "¿Qué son las cookies?",
      what_are_cookies_text:
        "Las cookies son pequeños archivos de datos que se colocan en tu ordenador o dispositivo móvil cuando visitas un sitio web. Las cookies son ampliamente utilizadas por los propietarios de sitios web para hacer que sus sitios funcionen, o funcionen de manera más eficiente, así como para proporcionar información de informes.",
      how_we_use: "Cómo utilizamos las cookies",
      how_we_use_text:
        "Utilizamos cookies por varias razones. Algunas cookies son necesarias por razones técnicas para que nuestro sitio web funcione, y nos referimos a ellas como cookies 'esenciales' o 'necesarias'. Otras cookies nos permiten rastrear y dirigir los intereses de nuestros usuarios para mejorar la experiencia en nuestro sitio web. Terceros sirven cookies a través de nuestro sitio web para publicidad, análisis y otros propósitos.",
      types: "Tipos de cookies que utilizamos",
      managing: "Gestión de tus cookies",
      managing_text:
        "Puedes configurar o modificar los controles de tu navegador web para aceptar o rechazar cookies. Si eliges rechazar cookies, aún puedes usar nuestro sitio web, aunque tu acceso a algunas funcionalidades y áreas de nuestro sitio web puede estar restringido. Como los medios por los cuales puedes rechazar cookies a través de los controles de tu navegador web varían de un navegador a otro, debes visitar el menú de ayuda de tu navegador para obtener más información.",
      third_party: "Cookies de terceros",
      third_party_text:
        "Además de nuestras propias cookies, también podemos utilizar varias cookies de terceros para informar sobre estadísticas de uso del sitio web, entregar anuncios en y a través del sitio web, y así sucesivamente.",
      updates: "Actualizaciones de esta Política de Cookies",
      updates_text:
        "Podemos actualizar esta Política de Cookies de vez en cuando para reflejar, por ejemplo, cambios en las cookies que utilizamos o por otras razones operativas, legales o normativas. Por lo tanto, visita nuevamente esta Política de Cookies con regularidad para mantenerte informado sobre nuestro uso de cookies y tecnologías relacionadas.",
      purpose: "Propósito",
      essential_purpose:
        "Necesarias para el correcto funcionamiento del sitio web. Estas cookies permiten funciones básicas como la navegación de páginas y el acceso a áreas seguras del sitio web.",
      functional_purpose:
        "Permiten que el sitio web recuerde las elecciones que haces (como tu nombre de usuario, idioma o la región en la que te encuentras) y proporciona características mejoradas y más personales.",
      analytics_purpose:
        "Nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web mediante la recopilación y el informe de información de forma anónima.",
      marketing_purpose:
        "Se utilizan para rastrear a los visitantes a través de sitios web. La intención es mostrar anuncios que sean relevantes y atractivos para el usuario individual.",
      always_active: "Siempre activo",
      active: "Activo",
      inactive: "Inactivo",
      back_to_site: "Volver al sitio",
    },
  },
  sidebar: {
    platform: "Plataforma",
    dashboard: "Panel de control",
    tasks: {
      title: "Tareas",
      add: "Añadir tarea"
    },
    analytics: "Analíticas",
    users: "Usuarios",
    settings: "Configuración",
    admin_panel: {
      title: "Panel de administración",
      mods: {
        title: "Mods",
        add: "Añadir mod"
      },
      labels: {
        title: "Etiquetas",
        add: "Añadir etiqueta"
      },
      pending: "Aprobaciones pendientes"
    },
    documentation: {
      title: "Documentaciones",
      create: "Crear documentación"
    },
    search: "Buscar en documentos..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "Resumen",
          userInfo: "Información del usuario",
          userId: "ID de usuario",
          role: "Rol",
          memberSince: "Miembro desde"
        },
        tasks: {
          title: "Tareas",
          assigned: "Tareas asignadas",
          noTasks: "Aún no hay tareas asignadas."
        },
        activity: {
          title: "Actividad",
          recent: "Actividad reciente",
          noActivity: "No hay actividad reciente."
        },
        settings: {
          title: "Configuración",
          user: "Configuración de usuario",
          admin: "Configuración de administrador para este usuario."
        }
      }
    },
    mods: {
      error: {
        unknownError: "Error desconocido"
      },
      access: {
        title: "Acceso denegado",
        description: "No tienes permiso para acceder a esta página."
      },
      add: {
        link: "Añadir nuevo mod",
        title: "Añadir nuevo mod",
        addDesc: "Crear una nueva entrada de mod",
        name: {
          title: "Nombre",
          placeholder: "Introduce el nombre del mod"
        },
        description: {
          title: "Descripción",
          placholder: "Introduce la descripción en "
        },
        optional: "Opcional",
        versions: {
          title: "Versiones",
          add: "Añadir versión"
        },
        icon: "URL del icono",
        launchers: "Lanzadores",
        form: {
          errors: {
            alert: {
              title: "Error",
              description: "Por favor, corrige los errores anteriores antes de enviar."
            },
            name: "El nombre es obligatorio",
            description: "La descripción en inglés (EE. UU.) es obligatoria",
            curseforge: "El enlace de CurseForge es obligatorio",
            invalidURL: "Formato de URL no válido",
            versions: "Se requiere al menos una versión",
            launchers: "Se requiere al menos un lanzador"
          }
        },
        cancel: "Cancelar",
        create: {
          loading: "Creando...",
          default: "Crear mod"
        },
        langDataError: "Error al cargar los datos de idioma:",
      },
      noMods: "No se encontraron mods",
      getStarted: "Comienza creando un nuevo mod.",
      fetch: {
        error: 'Error al obtener la documentación:'
      },
      "delete": {
        link: "Eliminar",
        confirm: "¿Estás seguro de que quieres eliminar este mod?"
      },
      toast: {
        delete: {
          success: {
            title: "Mod eliminado",
            description: "El mod ha sido eliminado con éxito."
          },
          error: {
            console: "Error al eliminar el mod:",
            fallback: "Error al eliminar el mod",
            title: "Error",
            description: "Se produjo un error al eliminar el mod."
          }
        },
        edit: {
          success: {
            title: "Éxito",
            description: "Mod actualizado con éxito"
          }
        },
        add: {
          fallback: "Error al crear el mod",
          success: {
            title: "Éxito",
            description: "Mod creado con éxito"
          },
          console: "Error al crear el mod:",
          error: {
            title: "Error",
            description: "Error al crear el mod"
          }
        }
      },
      noDesc: "No hay descripción disponible",
      docs: {
        link: "Documentación"
      },
      edit: {
        link: "Editar",
        title: "Editar mod",
        langDataError: "Error al cargar los datos de idioma:",
        notFound: "Mod no encontrado",
        failFetch: "Error al obtener el mod",
        unknownError: "Se produjo un error desconocido",
        form: {
          errors: {
            name: "El nombre es obligatorio",
            description: "La descripción en inglés (EE. UU.) es obligatoria",
            curseforge: "El enlace de CurseForge es obligatorio",
            versions: "Todos los campos de versión deben estar completos",
            launchers: "Se debe seleccionar al menos un lanzador"
          }
        },
        modInfo: "Información del mod",
        editModInfo: "Editar la información del mod.",
        name: "Nombre",
        description: {
          title: "Descripción",
          required: "La descripción en inglés (EE. UU.) es obligatoria."
        },
        optional: "Opcional",
        versions: {
          title: "Versiones",
          add: "Añadir versión",
          remove: "Eliminar"
        },
        icon: "URL del icono",
        launchers: "Lanzadores",
        cancel: "Cancelar",
        update: "Actualizar mod"
      }
    },
    docs: {
      access: {
        title: "Acceso denegado",
        description: "No tienes permiso para acceder a esta página."
      },
      title: "Documentación",
      description: "Navega y lee documentación para mods de Minecraft",
      create: {
        link: "Crear documentación",
        tab: "Crear nueva",
        content: {
          title: "No hay mods disponibles",
          description: "Todos los mods ya tienen documentación o no tienes permiso para crear documentación para ningún mod."
        },
        title: "Crear documentación"
      },
      published: "Publicado",
      pending: "Pendiente",
      noDocs: {
        title: "No hay documentación disponible",
        description: "Aún no hay páginas de documentación publicadas."
      },
      noPending: {
        title: "No hay documentación pendiente",
        superAdmin: "No hay páginas de documentación esperando aprobación",
        rest: "No tienes páginas de documentación pendientes."
      },
      user: {
        noDocs: {
          title: "No hay documentación disponible",
          description: "Aún no hay páginas de documentación publicadas."
        }
      },
      card: {
        pending: "Pendiente de aprobación",
        view: "Ver",
        edit: "Editar"
      },
      add: {
        title: "Crear nueva documentación",
        description: "Crea documentación completa para un mod de Minecraft",
        noMods: {
          title: "No hay mods disponibles",
          description: "No hay mods disponibles para la creación de documentación. O bien todos los mods ya tienen documentación o no tienes permiso para crear documentación para ningún mod."
        },
        card: {
          title: "Información básica",
          description: "Proporciona información básica sobre la documentación.",
          descriptionLink: "Ver nuestra guía de documentación",
          content: {
            modSelect: "Seleccionar un mod",
            modSelectDesc: "Selecciona el mod para el que quieres crear documentación",
            noDesc: "No hay descripción disponible",
            form: {
              title: {
                title: "Título",
                placeholder: "Introduce el título de la documentación",
                description: "El título de tu documentación (se requiere inglés EE. UU.)"
              },
              description: {
                title: "Descripción",
                placeholder: "Introduce la descripción de la documentación",
                description: "Una breve descripción de tu documentación (se requiere inglés EE. UU.)"
              },
              coverImage: {
                title: "URL de imagen de portada (Opcional)",
                description: "Proporciona una URL para la imagen de portada de tu documentación"
              },
              tabs: {
                preview: {
                  title: "Vista previa",
                  content: {
                    title: "Vista previa",
                    description: "Vista previa de cómo se verá tu documentación",
                    form: {
                      title: "Título de la documentación",
                      description: "La descripción de la documentación aparecerá aquí."
                    },
                    section: "sección",
                    article: "artículo",
                    modSelect: {
                      title: "Seleccionar un mod",
                      description: "Selecciona un mod para previsualizar tu documentación"
                    }
                  }
                },
                information: {
                  title: "Información",
                  content: {
                    title: "Información",
                    description: "Información importante sobre la creación de documentación",
                    approval: {
                      title: "Aprobación requerida",
                      description: "La documentación creada por editores y administradores requiere la aprobación de un superadministrador antes de hacerse pública. Abre un ticket para solicitarlo."
                    },
                    after: {
                      title: "Después de la creación:",
                      list: {
                        one: "Serás redirigido al editor de documentación",
                        two: "Se creará automáticamente una sección y un artículo predeterminados",
                        three: "Puedes añadir más secciones y artículos según sea necesario",
                        four: "Puedes subir imágenes y añadir componentes personalizados",
                        five: "Puedes previsualizar tu documentación antes de enviarla para su aprobación. (Debe guardarse antes de la vista previa)"
                      }
                    },
                    create: {
                      loading: "Creando...",
                      default: "Crear documentación"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "Error al obtener los mods",
          documentation: "Error al obtener las documentaciones"
        },
        success: {
          title: "Documentación creada",
          description: "Tu documentación ha sido creada con éxito."
        },
        error: {
          fetching: {
            mods: {
              console: "Error al obtener los mods:",
              toast: {
                title: "Error",
                description: "Error al cargar los mods. Por favor, inténtalo de nuevo."
              }
            }
          },
          creating: {
            failed: "Error al crear la documentación",
            error: {
              console: "Error al crear la documentación:",
              toast: {
                title: "Error",
                description: "Error al crear la documentación. Por favor, inténtalo de nuevo."
              }
            }
          }
        }
      }
    }
  }
}